
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import axios from "axios";
import { useRef, useState, useEffect } from "react";
import { AccessToken } from "../../config/AccessToken";

export const DevicesTileCounter = () => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [error, setError] = useState('');
  const [instance, accessTokenRequest] = AccessToken();
  let languageId = localStorage.getItem('languageId');

  const [counterDevices, setCounterDevices] = useState(null);

  useEffect(() => {
    const getDeviceCounter = async () => {

      const commonOperations = (accessToken: any) => {
        const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
        axios.get(`${SERVER_URL}/device/count`, { headers })
          .then((res) => {
            const data = res?.data
            setCounterDevices(data?.data?.deviceCount);
          }).catch((data) => {
            setError(data?.message);
          });
      }

      if (localStorage.getItem('accessToken') != null) {
        let accessToken = localStorage.getItem('accessToken');
        commonOperations(accessToken);
      }
      else {
        await instance.initialize();
        await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
          // Acquire token silent success
          let accessToken = accessTokenResponse.accessToken;
          commonOperations(accessToken);
        })
          .catch((error: any) => {
            if (error instanceof InteractionRequiredAuthError) {
              instance.acquireTokenRedirect(accessTokenRequest);
            }
            console.log(error);
          });
      }
    }

    getDeviceCounter();
  }, [])

  return (
    <div style={{ containerType: 'inline-size' }}>
      {/* <h1>{t('dashboard.widget.alarms')}</h1>       */}
      <div className="dashboard-card-content tag-counter" >
        <p className="dashboard-card-content-number tag-counter blue">{counterDevices}</p>
      </div>
    </div>
  );
};